<template>
  <div class="dimed wrap">
    <div class="layer layer--sm">
      <div class="layer__body" v-if="!retryYn">
        <div class="ft--xlg ft--bold">{{ text }}</div>
      </div>
      <div class="layer__body" v-if="retryYn">
        <div class="ft--xlg ft--bold">{{ $t('Admin.Common.msg1') }}</div>
      </div>
      <div class="layer__button" v-if="retryYn">
        <button class="btn btn--submit btn--xlg" @mouseup="retry()">{{ $t('User.WineFinish.msg98') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'posTransaction',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      retryYn: true,
      instance: axios.create({timeout: 30000}),
    };
  },
  mounted() {},
  props: {
    text: String,
    url: String,
    param: Object,
  },
  methods: {
    retry() {
      this.retryYn = false;
      this.posTransactionCall();
    },
    posTransactionCall() {
      this.$toggleProgressIcon(true);
      this.$logInfo(`Pos Transaction axios Call`);

      let url = '' + this.url;
      let param = this.param == null || this.param == '' ? {} : this.param;

      this.instance
        .post(url, param)
        .then((response) => {
          if (response.data.status == 0) {
            this.$emit('posTransactionNextStep', response);
          } else {
            this.retryYn = true;
            this.$logInfo(`Pos Transaction Fail status : ${response.data.status} message : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.retryYn = true;
          this.$logInfo(`Pos Transaction axios Error : ${error}`);
        })
        .finally(() => {
          this.$toggleProgressIcon(false);
        });
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.dimed {
  z-index: 35;
}
</style>
